const SESSION_KEY = "mawa_8d777f";

const encodeBase64 = (value) =>
	btoa(unescape(encodeURIComponent(value)));

const decodeBase64 = (value) =>
	decodeURIComponent(escape(atob(value)));

const isValidUserData = (userData) =>
	userData &&
	typeof userData === "object" &&
	typeof userData.nim === "string" &&
	userData.nim.trim().length > 0;

const decodeJwtPayload = (token) => {
	try {
		const [, payload] = String(token || "").split(".");
		if (!payload) return null;

		const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
		return JSON.parse(decodeBase64(normalizedPayload));
	} catch (_e) {
		return null;
	}
};

const isExpiredToken = (token) => {
	const payload = decodeJwtPayload(token);
	if (!payload?.exp) return false;

	return payload.exp * 1000 <= Date.now();
};

const setUserData = (userData) => {
	if (!isValidUserData(userData)) {
		invalidateSession();
		return;
	}

	sessionStorage.setItem(SESSION_KEY, encodeBase64(JSON.stringify(userData)));
};

const invalidateSession = () => {
	sessionStorage.removeItem(SESSION_KEY);
};

const getUser = () => {
	try {
		const encodedUser = sessionStorage.getItem(SESSION_KEY);
		if (!encodedUser) return {};

		const userData = JSON.parse(decodeBase64(encodedUser));
		if (!isValidUserData(userData) || isExpiredToken(userData.token)) {
			invalidateSession();
			return {};
		}

		return userData;
	} catch (_e) {
		invalidateSession();
		return {};
	}
};

const getUserData = () => getUser();

const checkUser = () => isValidUserData(getUserData());

export { setUserData, getUserData, invalidateSession, checkUser };
